/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { FaRecycle } from '@react-icons/all-files/fa/FaRecycle';
import { toast } from 'sonner';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { getAppReleaseShort } from '@/utils/appRelease';

const intervalMS = 1 * 60 * 1000;

const setNewWorkerActivating = (value: 'true' | 'false') =>
  localStorage.setItem('BILDERIT_ACTIVATING', value);

const getNewWorkerActivating = () =>
  localStorage.getItem('BILDERIT_ACTIVATING');

export default function ServiceWorkerLoader() {
  const lastAlert = React.useRef<string | number | null>(null);

  const { updateServiceWorker } = useRegisterSW({
    onRegisteredSW(
      swUrl: string,
      registration: ServiceWorkerRegistration | undefined
    ) {
      if (getNewWorkerActivating() === 'true') {
        setNewWorkerActivating('false');
        lastAlert.current && toast.dismiss(lastAlert.current);
        lastAlert.current = toast.success(SuccessAlert, {
          duration: 5000,
          onDismiss: () => {
            lastAlert.current = null;
          },
        });
      }

      registration &&
        setInterval(async () => {
          if (registration.installing || !navigator) return;

          if ('connection' in navigator && !navigator.onLine) return;

          const resp = await fetch(swUrl, {
            cache: 'no-store',
            headers: {
              cache: 'no-store',
              'cache-control': 'no-cache',
            },
          });

          if (resp?.status === 200) await registration.update();
        }, intervalMS);
    },
    onNeedRefresh() {
      setNewWorkerActivating('true');
      if (!lastAlert.current) {
        lastAlert.current = toast.loading(ForcedUpdateAlert);
      }
      setTimeout(() => updateServiceWorker(true), 3000);
    },
    onRegisterError(error: any) {
      toast.error('Hubo un error al registrar el Service Worker', error);
    },
  });

  return null;
}

const SuccessAlert = () => (
  <>
    <h4 className="alert-heading">Actualizacion completada</h4>
    <p>Estás corriendo la version {getAppReleaseShort()} de Bilderit</p>
  </>
);

const ForcedUpdateAlert = () => (
  <>
    <h4 className="alert-heading">Actualizacion disponible</h4>
    <p>
      Tu aplicación se está actualizando para obtener las últimas
      funcionalidades
    </p>
  </>
);

// eslint-disable-next-line no-unused-vars
const UpdateAlert = (cb: () => any) => (
  <>
    <h4 className="alert-heading">Actualizacion disponible</h4>
    <p onClick={cb}>
      Hacé click aqui para actualizar la aplicacion <FaRecycle />
    </p>
  </>
);
